<span
  data-automation-id="label-title"
  [ngClass]="availableStatuses.includes(status) ? 'label-available' : 'label-unavailable'">
    {{ label || 'other' | translate }}
</span>
